import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorBoundaryComponentError } from 'src/components/ErrorBoundary/ErrorBoundary.slice';
import type { ParameterTogglesViewDefn } from 'configuration-schemas/viewdefns/viewdefn';

export interface ParameterTogglesSlice {
  isConfigLoading: boolean;
  isDataLoading: boolean;
  viewDefn: ParameterTogglesViewDefn | undefined;
}

const initialSlice: ParameterTogglesSlice = {
  isConfigLoading: false,
  isDataLoading: false,
  viewDefn: undefined,
};

const parameterTogglesSliceReducer = createSlice({
  name: 'ParameterToggles',
  initialState: initialSlice,
  reducers: {
    requestParameterTogglesConfig(state) {
      state.isConfigLoading = true;
    },
    receiveParameterTogglesConfig(state, action: PayloadAction<ParameterTogglesViewDefn>) {
      state.isConfigLoading = false;
      state.viewDefn = action.payload;
    },
    receiveError(_state, _action: PayloadAction<ErrorBoundaryComponentError>) {
      return initialSlice;
    },
    cleanupParameterToggles() {
      return initialSlice;
    },
  },
});

export const { requestParameterTogglesConfig, receiveParameterTogglesConfig, cleanupParameterToggles, receiveError } =
  parameterTogglesSliceReducer.actions;
export default parameterTogglesSliceReducer.reducer;
